<template>
  <div v-if="false"></div> <!-- Hidden but active -->
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'UserTimeTracker',
  props: {
    // A unique ID for the route/page
    pageKey: {
      type: String,
      required: true,
    },
    idleLimitMs: {
      type: Number,
      default: 60000, // 1 min of inactivity = idle
    },
  },
  data () {
    return {
      activeTime: 0,
      lastStart: null,
      idleTimeout: null,
      visibilityHandler: null,
      storageKey: '',
    };
  },
  created () {
    this.storageKey = `tracking_${this.pageKey}`;

    const savedStart = localStorage.getItem(this.storageKey);
    if (!savedStart) {
      localStorage.setItem(this.storageKey, Date.now().toString());
    }

    this.startTracking();
  },
  methods: {
    ...mapActions({
      addCCMTimeLog: 'ccmTimeLogs/addCCMTimeLog',
      // addCCMVitalEntry: 'ccmVitalEntry/addCCMVitalEntry',
    }),
    startTracking () {
      // Start tracking if page is visible and user is active
      if (document.visibilityState === 'visible') {
        this.resumeTimer();
      }

      // Setup visibility change tracking
      this.visibilityHandler = () => {
        if (document.visibilityState === 'hidden') {
          this.pauseTimer();
        } else {
          this.resumeTimer();
        }
      };
      document.addEventListener('visibilitychange', this.visibilityHandler);

      // Setup user activity tracking
      ['mousemove', 'keydown', 'scroll'].forEach(evt => {
        window.addEventListener(evt, this.resetIdleTimer);
      });
      this.resetIdleTimer();

      // Handle unload
      window.addEventListener('beforeunload', this.cleanup);
    },

    resumeTimer () {
      if (!this.lastStart) {
        this.lastStart = Date.now();
      }
    },

    pauseTimer () {
      if (this.lastStart) {
        this.activeTime += Date.now() - this.lastStart;
        this.lastStart = null;
      }
      clearTimeout(this.idleTimeout);
    },

    resetIdleTimer () {
      clearTimeout(this.idleTimeout);
      if (!this.lastStart) {
        this.resumeTimer();
      }
      this.idleTimeout = setTimeout(() => {
        this.pauseTimer(); // User idle
      }, this.idleLimitMs);
    },

    async cleanup () {
      this.pauseTimer();

      const totalTime = this.activeTime;

      if (this.currentRecord === null) {
        // Remove tracking key
        localStorage.removeItem(this.storageKey);
        return;
      }

      const bodyRequest = {
        ccmRecordId: this.currentRecord.id,
        patientId: this.currentRecord.patientId,
        hospitalId: this.currentRecord.hospitalId,
        timestamp: new Date().toISOString(),
        timeSpentSeconds: parseInt(totalTime / 1000), // converting from milliseconds to seconds
        activityType: `REVIEWING_${this.pageKey.toUpperCase()}`,
        description: `Reviewing ${this.pageKey}`,
        staffId: this.userData.id,
        isBillable: true,
        relatedDiagnosisCode: '',
        additionalData: '',
      };
      await this.addCCMTimeLog(bodyRequest);

      // Remove tracking key
      localStorage.removeItem(this.storageKey);
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.authentication.userData,
      currentRecord: (state) => state.ccmRecords.ccmRecord,
    }),
  },
  beforeDestroy () {
    this.cleanup();
    document.removeEventListener('visibilitychange', this.visibilityHandler);
    ['mousemove', 'keydown', 'scroll'].forEach(evt => {
      window.removeEventListener(evt, this.resetIdleTimer);
    });
    window.removeEventListener('beforeunload', this.cleanup);
  },
};
</script>
